import pino, { LoggerOptions } from 'pino';
import { datadogLogs } from '@datadog/browser-logs';

export const getPinoConfig = (onPinoError: PinoError): LoggerOptions => ({
    level: process.env.LOG_LEVEL || 'info',
    name: `${process.env.NAME}-web`,
    prettyPrint: {
        singleLine: true,
    },
    browser: {
        serialize: true,
        asObject: true,
        write: {
            // eslint-disable-next-line @typescript-eslint/ban-types
            error: (error: object) => {
                onPinoError('React error', error as MessageContext);
            },
        },
    },
});

type PinoError = (message: string, messageContext: MessageContext) => void;

type MessageContext = {
    level: number;
    message: string;
    stack: string;
    time: number;
};

export const onPinoError: PinoError = (
    message: string,
    messageContext: {
        level: number;
        message: string;
        stack: string;
        time: number;
    }
) => datadogLogs.logger.error(message, messageContext);

export const log = pino(getPinoConfig(onPinoError));
